import type { AdminCategorySelectDto } from '@@types/api.types';
import { TooltipComponent } from '@components/core/tooltip.component';
import type React from 'react';

type AdminCategoryDependenciesProps = {
  category: AdminCategorySelectDto;
};

export const AdminCategoryDependencies: React.FC<AdminCategoryDependenciesProps> = (props) => {
  const { category } = props;

  const dependencies = [
    { label: 'Expert Profiles', count: category.dependencyCounts.expertProfilesCount },
    { label: 'Mission Assessment Inters', count: category.dependencyCounts.missionAssessmentIntersCount },
    { label: 'Mission Assessments', count: category.dependencyCounts.missionAssessmentsCount },
    { label: 'Subsystems', count: category.dependencyCounts.subsystemsCount },
    { label: 'Technologies', count: category.dependencyCounts.technologiesCount },
    { label: 'User Profiles', count: category.dependencyCounts.userProfilesCount },
  ].filter((dep) => dep.count > 0);

  return (
    <div className="p-4 rounded-lg border border-gray-200 bg-white">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold text-gray-900">Usage</h3>
          <TooltipComponent side="top">
            Entities (technologies, mission assessments, etc.) that are using this category.
          </TooltipComponent>
        </div>

        {category.totalDependencies === 0 ? (
          <p className="text-sm text-gray-500">This category is not being used.</p>
        ) : (
          <div className="space-y-1 text-sm">
            {dependencies.map((dep) => (
              <div
                key={dep.label}
                className="flex justify-between"
              >
                <span className="text-gray-600">{dep.label}:</span>
                <span className="font-medium">{dep.count}</span>
              </div>
            ))}
            <div className="flex font-semibold justify-between pt-1 border-t border-gray-200">
              <span className="text-gray-600">Total:</span>
              <span className="font-medium">{category.totalDependencies}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
